import { GamesEnum } from '@core/enums/games.enum';
import {
  CaseBattlesHistory,
  PlinkoHistory,
  TowersHistory,
  MinesHistory,
  CoinflipHistory,
  WheelHistory,
  JackpotHistory,
  UpgraderHistory,
  CasesHistory,
  KingUserHistory,
} from '../interfaces';

export interface GameHistorySetting {
  title: keyof typeof GamesEnum;
  key: string;
  endpoint: string;
}

export const gamesHistorySettings: Record<
  keyof typeof GamesEnum,
  GameHistorySetting
> = {
  ['Case Battles']: {
    title: 'Case Battles',
    key: 'case-battles',
    endpoint: 'get_my_case_battle_history',
  },
  Coinflip: {
    title: 'Coinflip',
    key: 'coinflip',
    endpoint: 'get_my_cf_history',
  },
  King: {
    title: 'King',
    key: 'king',
    endpoint: 'get_my_king_history',
  },
  'King New': {
    title: 'King New',
    key: 'king-new',
    endpoint: 'get_my_king_history',
  },
  Jackpot: {
    title: 'Jackpot',
    key: 'jackpot',
    endpoint: 'get_my_jp_history',
  },
  Cases: {
    title: 'Cases',
    key: 'case-open',
    endpoint: 'get_my_case_history',
  },
  Upgrade: {
    title: 'Upgrade',
    key: 'upgrader',
    endpoint: 'get_my_upgrader_history',
  },
  Wheel: {
    title: 'Wheel',
    key: 'wheel',
    endpoint: 'get_my_roulette_history',
  },
  Mines: {
    title: 'Mines',
    key: 'mines',
    endpoint: 'get_my_mines_history',
  },
  Towers: {
    title: 'Towers',
    key: 'towers',
    endpoint: 'get_my_towers_history',
  },
  Plinko: {
    title: 'Plinko',
    key: 'plinko',
    endpoint: 'get_my_plinko_history',
  },
};

type GamesHistoryStore = {
  [K in keyof typeof GamesEnum]: K extends 'Case Battles'
    ? CaseBattlesHistory[]
    : K extends 'Coinflip'
    ? CoinflipHistory[]
    : K extends 'King'
    ? KingUserHistory[]
    : K extends 'King New'
    ? KingUserHistory[]
    : K extends 'Jackpot'
    ? JackpotHistory[]
    : K extends 'Cases'
    ? CasesHistory[]
    : K extends 'Upgrade'
    ? UpgraderHistory[]
    : K extends 'Wheel'
    ? WheelHistory[]
    : K extends 'Mines'
    ? MinesHistory[]
    : K extends 'Towers'
    ? TowersHistory[]
    : K extends 'Plinko'
    ? PlinkoHistory[]
    : never;
};

export const gamesHistoryStore: GamesHistoryStore = {
  'Case Battles': [],
  Coinflip: [],
  King: [],
  'King New': [],
  Jackpot: [],
  Cases: [],
  Upgrade: [],
  Wheel: [],
  Mines: [],
  Towers: [],
  Plinko: [],
};
